import React from 'react';
import {useSelector} from "react-redux";
import {getRowNumber} from "mindsets-js-sdk";

import Row from './Row';

export default function () {
    const items = useSelector(state => state.votes);
    const current = useSelector(state => state.votes_current);
    const limit = useSelector(state => state.responses_limit);

    return (
        <div>
            <div className="table-responsive">
                <table className="table table-bordered table-hover">
                    <thead>
                    <tr className="text-center">
                        <th>No</th>
                        <th>Vote info</th>
                        <th>Student</th>
                        <th>Vote</th>
                    </tr>
                    </thead>
                    <tbody>
                    {items.map((item, index) => {
                        return (
                            <Row
                                key={item.id}
                                item={item}
                                row_number={getRowNumber(index, current, limit)}
                            />
                        );
                    })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
